import { useState } from 'react';
import './Coin.css';

const Coin = () => {
  const [side, setSide] = useState<string | null>(null);
  const [flipping, setFlipping] = useState(false);
  const [headsCount, setHeadsCount] = useState<number>(() => {
    return parseInt(sessionStorage.getItem('headsCount') || '0');
  });
  const [tailsCount, setTailsCount] = useState<number>(() => {
    return parseInt(sessionStorage.getItem('tailsCount') || '0');
  });
  const [throwCount, setThrowCount] = useState<number>(() => {
    return parseInt(sessionStorage.getItem('throwCount') || '100');
  });
  const [firstResult, setFirstResult] = useState<string | null>(() => {
    return sessionStorage.getItem('firstResult') || null;
  });
  const [isGameStarted, setIsGameStarted] = useState<boolean>(() => {
    return sessionStorage.getItem('isGameStarted') === 'true';
  });
  const [isFullyEnded, setIsFullyEnded] = useState<boolean>(() => {
    return sessionStorage.getItem('isFullyEnded') === 'true';
  });

  // Расчёт процента везения
  const calculateLuck = () => {
    if (!firstResult || throwCount !== 0) return null;
    const relevantCount = firstResult === 'ОРЕЛ' ? headsCount : tailsCount;
    const percentage = (relevantCount / 100) * 100; // Вероятность в процентах
    return percentage.toFixed(0);
  };

  const luckPercentage = calculateLuck();

  const handleStartClick = () => {
    if (!isGameStarted || throwCount === 0) {
      // Начать или сбросить игру
      setSide(null);
      setHeadsCount(0);
      setTailsCount(0);
      setThrowCount(100);
      setFirstResult(null);
      setIsGameStarted(true);
      setIsFullyEnded(false);
      sessionStorage.setItem('coinSide', '');
      sessionStorage.setItem('headsCount', '0');
      sessionStorage.setItem('tailsCount', '0');
      sessionStorage.setItem('throwCount', '100');
      sessionStorage.setItem('firstResult', '');
      sessionStorage.setItem('isGameStarted', 'true');
      sessionStorage.setItem('isFullyEnded', 'false');
    }
  };

  const handleCoinClick = () => {
    if (flipping || !isGameStarted || isFullyEnded) return;

    if (throwCount === 0) {
      // Холостой клик: сбрасываем на "МОНЕТА"
      setSide(null);
      setIsFullyEnded(true);
      sessionStorage.setItem('coinSide', '');
      sessionStorage.setItem('isFullyEnded', 'true');
      return;
    }

    setFlipping(true);

    setTimeout(() => {
      const rand = Math.random();
      const result = rand < 0.5 ? 'ОРЕЛ' : 'РЕШКА';

      setSide(result);

      // Первый бросок: только РПБ, без статистики и уменьшения бросков
      if (!firstResult) {
        setFirstResult(result);
        sessionStorage.setItem('firstResult', result);
      } else {
        // Остальные броски: обновляем статистику и уменьшаем броски
        setThrowCount((prev) => {
          const newCount = Math.max(prev - 1, 0);
          sessionStorage.setItem('throwCount', newCount.toString());
          return newCount;
        });

        if (result === 'ОРЕЛ') {
          setHeadsCount((prev) => {
            const newCount = prev + 1;
            sessionStorage.setItem('headsCount', newCount.toString());
            return newCount;
          });
        } else {
          setTailsCount((prev) => {
            const newCount = prev + 1;
            sessionStorage.setItem('tailsCount', newCount.toString());
            return newCount;
          });
        }
      }

      setFlipping(false);
      sessionStorage.setItem('coinSide', result);
    }, 1000);
  };

  return (
    <div className="coin-wrapper">
      <div className="left-column">
        {/* Кнопка НАЧАТЬ */}
        <div className="counter-section">
          <div
            className={`start-button ${!isGameStarted || throwCount === 0 ? '' : 'disabled'}`}
            onClick={handleStartClick}
          >
            НАЧАТЬ
          </div>
        </div>

        {/* РПБ */}
        <div className="counter-section">
          <span className="counter-label">РПБ: </span>
          <span className={`counter-box2 rpb-box ${firstResult ? 'rpb-set' : ''}`}>
            {firstResult || '-'}
          </span>
        </div>

        {/* Орел */}
        <div className="counter-section">
          <span className="counter-label">ОРЕЛ: </span>
          <span className="counter-box">{headsCount}</span>
        </div>

        {/* Решка */}
        <div className="counter-section">
          <span className="counter-label">РЕШКА: </span>
          <span className="counter-box">{tailsCount}</span>
        </div>

        {/* Бросок */}
        <div className="counter-section">
          <span className="counter-label">БРОСОК: </span>
          <span className="counter-box">{throwCount}</span>
        </div>

        {/* Процент везения */}
        {luckPercentage !== null && (
          <div className="counter-section luck-percentage">
            <span className="counter-label">ВЕЗЕНИЕ: </span>
            <span className="counter-box rpb-box">{luckPercentage}%</span>
          </div>
        )}
      </div>

      <div className="right-column">
        {/* Монета */}
        <div
          className={`coin ${flipping ? 'flipping' : ''} ${
            !isGameStarted || throwCount === 0 ? (isFullyEnded ? 'fully-disabled' : 'disabled') : ''
          }`}
          onClick={handleCoinClick}
        >
          <span>{side || 'МОНЕТА'}</span>
        </div>
      </div>
    </div>
  );
};

export default Coin;